export default "__VITE_ASSET__BN37aJLX__"